/**
 * Manage Recently Viewed Products Action
 * Triggered by: arc:action:recentlyViewedManage
 */

const COOKIE_NAME = 'arc_recently_viewed';
const COOKIE_DAYS = 30;

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}

function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

function deleteCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
}

export const runRecentlyViewedManage = async (data = {}) => {
    try {
        const { action = 'clear', productId, limit = 20 } = data;

        const currentIds = JSON.parse(getCookie(COOKIE_NAME) || '[]');
        let updatedIds = [...currentIds];
        let message = '';

        switch (action) {
            case 'clear':
                deleteCookie(COOKIE_NAME);
                updatedIds = [];
                message = 'Recently viewed products cleared';
                break;

            case 'remove':
                if (!productId) {
                    throw new Error('Product ID is required for remove action');
                }
                const normalizedId = String(productId).replace('gid://shopify/Product/', '');
                updatedIds = currentIds.filter(id => String(id).replace('gid://shopify/Product/', '') !== normalizedId);
                setCookie(COOKIE_NAME, JSON.stringify(updatedIds), COOKIE_DAYS);
                message = 'Product removed from recently viewed';
                break;

            case 'trim':
                updatedIds = currentIds.slice(0, limit);
                setCookie(COOKIE_NAME, JSON.stringify(updatedIds), COOKIE_DAYS);
                message = `Recently viewed list trimmed to ${limit} products`;
                break;

            default:
                throw new Error(`Unknown action: ${action}`);
        }

        window.dispatchEvent(new CustomEvent('recentlyViewed:updated', {
            detail: {
                products: updatedIds,
                action,
                removedProductId: action === 'remove' ? productId : null
            }
        }));

        return {
            success: true,
            products: updatedIds,
            action,
            message
        };

    } catch (error) {
        console.error('Recently Viewed Manage error:', error);

        window.dispatchEvent(new CustomEvent('recentlyViewed:error', {
            detail: {
                error: error.message,
                action: 'manage'
            }
        }));

        return {
            success: false,
            error: error.message
        };
    }
};

export default runRecentlyViewedManage;
